<!--
CREATE TABLE `merchant_pos` (
  `id` int(11) NOT NULL AUTO_INCREMENT COMMENT 'ID',
  `pid` int(11) DEFAULT NULL COMMENT '上级ID',
  `merchant_no` varchar(50) COMMENT '账户',
  `merchant_name` varchar(100) COMMENT '名称',
  `ancestor_ids` varchar(255) COMMENT '路径ID',
  `ancestor_name` varchar(255) COMMENT '路径名称',
  `province` varchar(50) COMMENT '省份',
  `city` varchar(50) COMMENT '城市',
  `wechat_no` varchar(50) COMMENT '微信账户',
  `alipay_no` varchar(50) COMMENT '阿里账户',
  `merchant_contact` varchar(50) COMMENT '法人/联系人',
  `phone` varchar(50) COMMENT '联系电话',
  `address` varchar(255) COMMENT '注册地址',
  `pos_terminal_no` varchar(50) COMMENT 'POS机终端编号',
  `terminal_no` varchar(50) COMMENT '终端编号',
  `open_id` varchar(50) COMMENT '操作员',
  `password` varchar(50) COMMENT '交易密码',
  `cert_password` varchar(50) COMMENT '证书密码',
  `cert_name` varchar(20) COMMENT '证书名称',
  `cert_file` varchar(255) COMMENT '秘钥文件',
  `status` tinyint(1) DEFAULT '0' COMMENT '0待登记，1已登记，2已通过，3未通过',
  `pindex_id` int(6) DEFAULT '0' COMMENT '项目id',
  `msg` varchar(255) COMMENT '验证信息',
  `level` tinyint(2) DEFAULT '0' COMMENT '等级',
  `create_time` datetime DEFAULT NULL COMMENT '创建时间',
  `update_time` datetime DEFAULT NULL COMMENT '修改时间',
  PRIMARY KEY (`id`)
) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COMMENT='建行POS机架构';
-->
<template>
  <div class="merchant-pos-wrap">
    <!-- 左侧树 -->
    <div class="tree-panel">
      <div class="tree-header">商户架构</div>
      <el-input v-model="treeFilter" placeholder="搜索商户" size="mini" clearable style="padding:8px" />
      <div class="tree-body">
        <el-tree
          ref="tree"
          :data="treeData"
          :props="{ children: 'children', label: 'label' }"
          :filter-node-method="filterNode"
          node-key="id"
          highlight-current
          :expand-on-click-node="false"
          @node-click="onNodeClick"
        >
          <span slot-scope="{ node, data }" class="tree-node">
            <i class="el-icon-office-building" v-if="data.id===0" />
            <i class="el-icon-user" v-else />
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </div>

    <!-- 右侧列表 -->
    <div class="table-panel">
      <div class="search-box">
        <el-input v-model="query.merchant_name" placeholder="商户名称" size="mini" style="width:180px" />
        <el-input v-model="query.merchant_no" placeholder="商户号" size="mini" style="width:180px" />
        <el-input v-model="query.terminal_no" placeholder="终端编号" size="mini" style="width:180px" />
        <el-button type="primary" @click="getList" size="mini">搜索</el-button>
      </div>

      <el-table :data="pageData.list" border height="calc(100vh - 200px)" size="mini">
        <el-table-column prop="id" label="ID" width="60" fixed />
        <el-table-column prop="merchant_name" label="商户名称" width="150" show-overflow-tooltip fixed />
        <el-table-column prop="merchant_no" label="商户号" width="120" show-overflow-tooltip />
        <el-table-column prop="terminal_no" label="终端编号" width="100" />
        <el-table-column prop="pos_terminal_no" label="POS终端编号" width="120" show-overflow-tooltip />
        <el-table-column prop="merchant_contact" label="法人/联系人" width="100" />
        <el-table-column prop="phone" label="联系电话" width="110" />
        <el-table-column prop="province" label="省份" width="70" />
        <el-table-column prop="city" label="城市" width="70" />
        <el-table-column prop="address" label="注册地址" width="160" show-overflow-tooltip />
        <el-table-column prop="wechat_no" label="微信账户" width="120" show-overflow-tooltip />
        <el-table-column prop="alipay_no" label="阿里账户" width="120" show-overflow-tooltip />
        <el-table-column prop="open_id" label="操作员" width="90" show-overflow-tooltip />
        <el-table-column prop="cert_name" label="证书名称" width="80" />
        <el-table-column prop="status" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status===0" type="info" size="mini">待登记</el-tag>
            <el-tag v-else-if="scope.row.status===1" type="warning" size="mini">已登记</el-tag>
            <el-tag v-else-if="scope.row.status===2" type="success" size="mini">已通过</el-tag>
            <el-tag v-else-if="scope.row.status===3" type="danger" size="mini">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="level" label="等级" width="60" />
        <el-table-column prop="msg" label="验证信息" width="140" show-overflow-tooltip />
        <el-table-column prop="create_time" label="创建时间" width="140" />
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page="pageData.page"
        :page-size="pageData.size"
        layout="total, prev, pager, next, sizes"
        :total="pageData.total"
        :page-sizes="[10, 20, 50, 100]"
        style="margin-top:10px;text-align:right"
      />
    </div>
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'MerchantPos',
  data() {
    return {
      treeFilter: '',
      treeData: [],
      selectedNodeId: null,
      query: {
        merchant_name: "",
        merchant_no: "",
        terminal_no: "",
      },
      pageData: {
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
    }
  },
  watch: {
    treeFilter(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
    this.getTree()
    this.getList()
  },
  methods: {
    // ====================== 获取树数据 ======================
    getTree() {
      Http.post('MerchantPos/tree', {}, res => {
        if (res.code === 200) {
          const flatList = res.data || []
          this.treeData = this.buildTree(flatList)
        }
      })
    },

    // ====================== 扁平数据建树 ======================
    buildTree(list) {
      const map = {}
      const roots = []
      // 先建映射，加一个"全部"虚拟根
      const allNode = { id: 0, pid: null, label: '全部商户', children: [] }
      list.forEach(item => {
        map[item.id] = { ...item, children: [] }
      })
      list.forEach(item => {
        const node = map[item.id]
        const pid = item.pid || 0
        if (pid === 0 || !map[pid]) {
          allNode.children.push(node)
        } else {
          map[pid].children.push(node)
        }
      })
      // 清理空children
      const clean = (nodes) => {
        nodes.forEach(n => {
          if (n.children.length === 0) {
            delete n.children
          } else {
            clean(n.children)
          }
        })
      }
      clean(allNode.children)
      return [allNode]
    },

    // ====================== 树节点过滤 ======================
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },

    // ====================== 点击树节点 ======================
    onNodeClick(data) {
      this.selectedNodeId = data.id === 0 ? null : data.id
      this.pageData.page = 1
      this.getList()
    },

    // ====================== 获取列表 ======================
    getList() {
      let chain = Params.ins()
        .where(this.query.merchant_name ? ['merchant_name', 'like', '%' + this.query.merchant_name + '%'] : null)
        .where(this.query.merchant_no ? ['merchant_no', '=', this.query.merchant_no] : null)
        .where(this.query.terminal_no ? ['terminal_no', '=', this.query.terminal_no] : null)

      // 按选中节点筛选
      if (this.selectedNodeId) {
        chain = chain.where(['pid', '=', this.selectedNodeId])
      }

      const params = chain
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('MerchantPos/index', params, res => {
        if (res.code === 200) {
          this.pageData = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.merchant-pos-wrap {
  display: flex;
  height: 100vh;
  padding: 10px;
  gap: 10px;

  .tree-panel {
    width: 280px;
    min-width: 280px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    background: #fff;

    .tree-header {
      padding: 10px 12px;
      font-size: 14px;
      font-weight: bold;
      border-bottom: 1px solid #e6e6e6;
      background: #f5f7fa;
    }

    .tree-body {
      flex: 1;
      overflow-y: auto;
      padding: 4px 0;
    }

    .tree-node {
      display: flex;
      align-items: center;
      font-size: 13px;

      i {
        margin-right: 5px;
        color: #409eff;
      }

      .tree-node-label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .table-panel {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .search-box {
      margin-bottom: 10px;
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/PosDevice/MerchantPos.vue